import { useIntl } from '@weenat/wintl'
import { useSearchParams } from 'app/routx-router'
import EmptyStateWithRipple from 'app/src/kit/empty-state/EmptyStateWithRipple'
import Icons from 'app/src/kit/Icons'
import Text from 'app/src/kit/Text'
import isNil from 'lodash-es/isNil'
import { BackButton, ResendEmailLink } from 'routes/auth/verify-email/[verifyEmailKey]'

export const Component = () => {
  const { t } = useIntl()
  const [params] = useSearchParams()
  const errorCode =
    !isNil(params) &&
    typeof params === 'object' &&
    'errorCode' in params &&
    typeof params.errorCode === 'string'
      ? Number.parseInt(params.errorCode, 10)
      : 0
  return (
    <>
      <Text $fontSize='lg'>{t('auth.verification_success_title')}</Text>
      <div>
        <EmptyStateWithRipple
          tint='feedback.error.500'
          title={
            errorCode === 404
              ? t('auth.verify_email_link_expired')
              : t('errors.noun', { capitalize: true })
          }
          description={
            errorCode === 404
              ? t('auth.verify_email_link_expired_explained')
              : t('auth.verify_email_not_found')
          }
          Icon={Icons.Error}
        >
          <Flex $flexDirection='column' $gap='lg' $mt='lg'>
            <ResendEmailLink />
            <BackButton />
          </Flex>
        </EmptyStateWithRipple>
      </div>
    </>
  )
}
export default Component
